// ja strings for messages/hub.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const hub: Dict = {
  // Rendered as "<count> <on>" after the platform icons.
  "hub.views.count": "100億回以上",
  "hub.views.on": "の再生",
  "hub.badge.covers": "1,000万曲以上のカバー",
  "hub.badge.quality": "スタジオ品質",
  "hub.badge.youtube": "YouTubeで話題",
  "hub.trending": "トレンド",
  "hub.popular": "いま人気のボイス",
  "hub.browseAll": "すべて見る",
  "hub.byCategory": "カテゴリからボイスを探す",
  "hub.aiVoices": "AIボイス",
  "hub.howItWorks": "使い方",
  "hub.faq": "よくある質問",
  "hub.keepExploring": "ほかにも見る",
  "hub.moreWays": "Jammableでできること",
  "hub.home": "ホーム",

  "widget.title": "ボイスを選んでスタート",
  "widget.search": "ボイスを検索",
  "widget.clear": "検索をクリア",
  "widget.matching": "「{q}」に一致するボイス",
  "widget.popular": "いま人気",
  "widget.noMatch": "一致するボイスが見つかりません。",
  "widget.searchAny": "上の検索欄から好きなボイスを探せます。",
  "widget.coverWith": "{name}でカバーを作成",
  "widget.start": "好きなボイスで始める",
  "widget.rights":
    "次に音声を追加します。アップロードできるのは、権利を持っている音声だけです。",

  "lang.viewThisPage": "このページを日本語で見る",
  "lang.dismiss": "閉じる",
};

export default hub;
